document.querySelectorAll(".promo-box.lux-clickable").forEach((box) => {
    box.addEventListener("click", () => {
        /** @type {HTMLElement} */ (box.querySelector(".btn")).click();
    });
});

export {};
